import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainPoints } from './components/PainPoints';
import { ChaptersAccordion } from './components/ChaptersAccordion';
import { Bonuses } from './components/Bonuses';
import { BookPreview } from './components/BookPreview';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { PurchasePopup } from './components/PurchasePopup';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-cyan-200 selection:text-cyan-900" data-id="element-0">
      <MetaPixel data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProofBar data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ChaptersAccordion data-id="element-6" />
        <Bonuses data-id="element-7" />
        <BookPreview data-id="element-8" />
        <Testimonials data-id="element-9" />
        <PurchaseSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <PurchasePopup data-id="element-12" />
    </div>;
}